import { render, staticRenderFns } from "./RecentLibraryFolders.vue?vue&type=template&id=4be933f4&scoped=true"
import script from "./RecentLibraryFolders.vue?vue&type=script&lang=js"
export * from "./RecentLibraryFolders.vue?vue&type=script&lang=js"
import style0 from "./RecentLibraryFolders.vue?vue&type=style&index=0&id=4be933f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be933f4",
  null
  
)

export default component.exports